/**
 * Mettre à jour, ou créer une copie ? La règle, seule et testable.
 *
 * LE DÉFAUT QU'ELLE FERME.
 *
 * L'atelier gardait en mémoire l'identifiant de la fiche déjà enregistrée.
 * Quand la RÉVISION correspondante manquait — mémoire écrite avant que ce
 * champ existe —, il allait la lire sur le serveur et l'envoyait avec son
 * contenu local. Scénario mesuré :
 *
 *     l'atelier tient A,B, identifiant connu, révision inconnue
 *     H enregistre A,D                              → révision 2
 *     l'atelier ajoute C à sa sélection locale
 *     il relit la révision 2 et envoie A,B,C        → accepté, révision 3
 *     D a disparu, avec un message de réussite
 *
 * Une révision fraîchement récupérée ne dit RIEN de ce que l'appelant a vu.
 * S'en servir pour écrire, c'est fabriquer le laissez-passer qui contourne la
 * protection. Limiter l'exception à « une fois » ne rend pas cette première
 * écriture sûre : c'est précisément là que la perte se produit.
 *
 * LA RÈGLE. Sans révision connue, on n'écrase rien : on ENREGISTRE UNE
 * NOUVELLE FICHE. Le travail local est préservé, rien d'existant n'est
 * touché, et l'utilisateur repart avec un identifiant et une révision qui
 * vont ensemble. Une copie de trop se supprime ; une fiche effacée, non.
 */

/** « creer » | « mettre-a-jour ». */
export function decisionDEnregistrement({ sheetUid, revisionConnue }) {
  if (!sheetUid) return "creer";
  // Une révision est un entier >= 1. `NaN` passe `typeof … === "number"` et
  // échoue toutes les comparaisons : sans `Number.isInteger`, il aurait été
  // pris pour une révision valide et aurait rouvert le trou.
  if (!Number.isInteger(revisionConnue) || revisionConnue < 1) return "creer";
  return "mettre-a-jour";
}

/**
 * Faut-il prévenir l'utilisateur que sa fiche est repartie en copie ?
 *
 * Oui exactement quand il avait un identifiant : il s'attendait à une mise à
 * jour, il aura une seconde fiche. Le lui cacher serait le laisser croire que
 * l'ancienne a été modifiée.
 */
export function copieInattendue({ sheetUid, revisionConnue }) {
  return Boolean(sheetUid)
    && decisionDEnregistrement({ sheetUid, revisionConnue }) === "creer";
}
